import db from '@/firebase/init'

//var moment = require('moment')

export default {

    data () {
      return {
        csvExport: {
          d: [
            this.dateUTC2Local(new Date()).toISOString().substr(0,10),
            this.dateUTC2Local(new Date()).toISOString().substr(0,10)
          ],
          dates: [],
          data: [],
          did: null,
          loading: false
        }
      }
    },

    methods: {

        dateUTC2Local(date) {
          var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60000)
          var offset = date.getTimezoneOffset() / 60
          var hours = date.getHours()
          newDate.setHours(hours - offset)
          return newDate
        },

        showCsvExportModal(did) {
          this.csvExport.did = did
          this.$refs['csvExportDialog'].show()
        },
        hideCsvExportModal() {
          this.$refs['csvExportDialog'].hide()
        },

        dishWasherCsvInit() {
          this.csvExport.loading = true
          let dates = this.csvExport.d[0].localeCompare(this.csvExport.d[1]) > 0
            ? [this.csvExport.d[1], this.csvExport.d[0]]
            : this.csvExport.d
          let date = dates[0]
          this.csvExport.dates = []
          this.csvExport.data = []
          this.csvExport.cursor = []
          while(date.localeCompare(dates[1]) < 1) {
            this.csvExport.dates.push(date.replace("-", "").replace("-", ""))
            date = (new Date(new Date(date).getTime() + 86400000)).toISOString().substr(0,10)
          }
          this.dishWasherCsvFetch(0)
        },

        dishWasherCsvFetch(cursor) {
          if(cursor >= this.csvExport.dates.length) {
            this.csvExport.data.unshift([
              this.$t('common.date'),
              this.$t('common.time'),
              this.$t('dishwasher.boilerT'),
              this.$t('dishwasher.washingTankT'),
              this.$t('dishwasher.waterCons'),
              this.$t('dishwasher.evWash'),
              this.$t('dishwasher.evClean'),
              this.$t('dishwasher.electricity'),
              this.$t('dishwasher.electricityConsumption')
            ])
            this.downloadCsv(this.csvExport.data, 'dishwasher_')
            this.csvExport.loading = false
            return
          }
          const colMap = {
            boilerT: {col: 0},
            washingTankT: {col: 1},
            waterConsumption: {col: 2},
            washing: {col: 3, val: true},
            cleaning: {col: 4, val: true},
            electricity: {col: 5},
            electricityConsumption: {col: 6}
          }
          db.collection("devices/"+this.csvExport.did+"/logs").doc(this.csvExport.dates[cursor]).get().then((doc) => {
              if (doc.exists) {
                  let d = doc.data().rows
                  let ts, row, col, hits
                  for(let i in d) {
                    ts = (new Date(d[i].time)).toISOString()
                    hits = 0
                    row = [
                      ts.substr(0,10),
                      ts.substr(11,8),
                      '',
                      '',
                      '',
                      '',
                      '',
                      '',
                      ''
                    ]
                    for(col in colMap) {
                      if(col in d[i] && (!('val' in colMap[col]) || colMap[col].val === d[i][col])) {
                        row[2 + colMap[col].col] = d[i][col]
                        hits++
                      }
                    }
                    if(hits) { this.csvExport.data.push(row) }
                  }
              }
              return this.dishWasherCsvFetch(++cursor)
          }).catch((error) => {
            console.log(error)
            return this.dishWasherCsvFetch(++cursor)
          })
        },

        saveDishwasherCanisterChange(device) {
            device.flash = null
            if(confirm(this.$t('dishwasher.err.confirmCan'))) {
              db.collection("devices").doc(device.id).update({
                "status.washCyclesLDetergent": 0,
                "status.canister": "full",
                "status.detergentConsumed": 0
              }).then(() => {
                  device.flash = this.$t('dishwasher.err.canChanged')
              })
              .catch((error) => {
                  device.flash = error
              })
            }
          },

          saveDishwasherChanges(device) {
            device.flash = null
            var u = {
              "status.detergentConcentration": parseFloat(device.data.rows[device.data.index.detergentConcentration].val),
              "status.detergentCanisterWeight": parseFloat(device.data.rows[device.data.index.detergentCanisterWeight].val)
            }
            if(isNaN(u["status.detergentConcentration"]) || u["status.detergentConcentration"] <= 0 
            || isNaN(u["status.detergentCanisterWeight"]) || u["status.detergentCanisterWeight"] <= 0) {
              device.flash = this.$t('dishwasher.err.detergentParams')
              return
            }
            db.collection("devices").doc(device.id).update(u)
            .then(() => {
                device.flash = this.$t('common.devSaved')
                device.editform = false
            })
            .catch((error) => {
                device.flash = error
            })
          },

    }

}



// WEBPACK FOOTER //
// ./src/components/Devices/Dishwasher.js